<div class="ws-popup-header">
  <div>{{ "Advanced Filter" | translate }}</div>

  <div class="actions">
    <button (click)="closeClicked()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div class="ws-popup-content">
  <div class="ws-popup-body filter-wrapper">
    <form [formGroup]="form">
      <div class="form-container">
        <div *ngFor="let ad of advancedFilter" class="field-wrapper">
          <label [for]="ad.id">
            {{ ad.label | translate }}
          </label>

          <div class="input-wrapper">
            <input
              *ngIf="
                ad.type == 'text' || ad.type == 'number' || ad.type == 'email'
              "
              [formControlName]="ad.id"
              [id]="ad.id"
              [type]="ad.type"
              matInput
            />

            <div *ngIf="ad.type === 'currency'" class="currency-inputs">
              <input
                [formControl]="shh(form!.get(ad.id)!.get('gte'))"
                id="{{ ad.id }}-gte"
                mask="separator.2"
                matInput
                placeholder="{{ 'Min' | translate }}"
                thousandSeparator="."
                type="text"
              />

              <input
                [formControl]="shh(form!.get(ad.id)!.get('lte'))"
                id="{{ ad.id }}-lte"
                mask="separator.2"
                matInput
                placeholder="{{ 'Max' | translate }}"
                thousandSeparator="."
                type="text"
              />
            </div>

            <div
              *ngIf="ad.type === 'presence'"
              (click)="openQrModal(shh(form!.get(ad.id)), ad.options)"
            >
              <input
                [value]="chosenPresenceOptions(shh(form!.get(ad.id)))"
                readonly
              />
            </div>

            <div *ngIf="ad.type === 'date'" class="date-picker-input">
              <input
                (focus)="picker.open()"
                [formControlName]="ad.id"
                [matDatepicker]="picker"
                matInput
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>

            <mat-form-field
              *ngIf="ad.type === 'date-interval'"
              class="example-form-field"
            >
              <mat-date-range-input
                (click)="campaignOnePicker.open()"
                [rangePicker]="campaignOnePicker"
              >
                <input
                  [formControl]="shh(form!.get(ad.id)!.get('start'))"
                  matStartDate
                  readonly
                />
                <input
                  [formControl]="shh(form!.get(ad.id)!.get('end'))"
                  matEndDate
                  readonly
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                [for]="campaignOnePicker"
                matSuffix
              ></mat-datepicker-toggle>
              <mat-date-range-picker #campaignOnePicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field
              (click)="datepicker.open()"
              *ngIf="ad.type === 'multiselect-date'"
              appearance="fill"
              class="multiselect-date"
            >
              <mat-chip-list #chipList>
                <mat-chip
                  (removed)="removeDate(date, ad.id)"
                  *ngFor="let date of dates"
                >
                  {{ date | date : "dd/MM/yyyy" }}
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input
                  (dateChange)="dateChanged($event)"
                  [formControlName]="ad.id"
                  [matChipInputFor]="chipList"
                  [matDatepicker]="datepicker"
                  hidden
                />
              </mat-chip-list>
              <mat-datepicker-toggle
                [for]="datepicker"
                matSuffix
              ></mat-datepicker-toggle>
              <mat-datepicker
                #datepicker
                [dateClass]="dateClass"
              ></mat-datepicker>
            </mat-form-field>

            <ws-searchbar
              *ngIf="ad.id === 'experienceId'"
              [config]="experienceSearchConfig"
              [searchFunction]="searchExperiences.bind(this, ad)"
              [resultMapper]="mapExperienceResult.bind(this, ad)"
              [selectedItems]="form?.get(ad.id)?.value || []"
              (selectedItemsChange)="onExperienceSelectionChange(ad.id, $event)"
            >
            </ws-searchbar>

            <!-- Single-select: do not bind selectedItems — that input clears [selected] on init/reopen. -->
            <ws-selector
              *ngIf="ad.type === 'select' && ad.id !== 'experienceId'"
              [options]="ad.options"
              [selected]="form?.get(ad.id)?.value"
              [formatter]="getOptionName.bind(this, ad)"
              (selectedChange)="onSelectorChange($any(ad.id), $event, false)"
              [placeholder]="'Select option' | translate"
            >
            </ws-selector>

            <ws-selector
              *ngIf="ad.type === 'multiselect' && ad.id !== 'experienceId'"
              [options]="ad.options"
              [selectedItems]="form?.get(ad.id)?.value || []"
              [multiSelect]="true"
              [formatter]="getOptionName.bind(this, ad)"
              (selectedItemsChange)="onSelectedItemsChange(ad, $event)"
              [placeholder]="'Select option' | translate"
            >
            </ws-selector>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="ws-popup-footer">
    <span></span>
    <div class="actions-wrapper">
      <ws-button
        [callToActionType]="'danger'"
        (click)="resetClicked()"
        style="margin-right: 10px"
      >
        {{ "Remove" | translate }}
      </ws-button>
      <ws-button
        [callToActionType]="'primary'"
        type="submit"
        (click)="submitClicked()"
      >
        {{ "Search" | translate }}
      </ws-button>
    </div>
  </div>
</div>
